<template>
  <g>
    <path
      d="M14 9.00024H21C21.55 9.00024 22 8.55024 22 8.00024C22 7.45024 21.55 7.00024 21 7.00024H14C13.45 7.00024 13 7.45024 13 8.00024C13 8.55024 13.45 9.00024 14 9.00024Z"
    />
    <path
      d="M21 15.0002H14C13.45 15.0002 13 15.4502 13 16.0002C13 16.5502 13.45 17.0002 14 17.0002H21C21.55 17.0002 22 16.5502 22 16.0002C22 15.4502 21.55 15.0002 21 15.0002Z"
    />
    <path
      d="M21 11.0002H17C16.45 11.0002 16 11.4502 16 12.0002C16 12.5502 16.45 13.0002 17 13.0002H21C21.55 13.0002 22 12.5502 22 12.0002C22 11.4502 21.55 11.0002 21 11.0002Z"
    />
    <path
      d="M8.85 7.85018C8.54 7.54018 8 7.76018 8 8.21018V11.0002H3C2.45 11.0002 2 11.4502 2 12.0002C2 12.5502 2.45 13.0002 3 13.0002H8V15.7902C8 16.2402 8.54 16.4602 8.85 16.1402L12.64 12.3502C12.84 12.1502 12.84 11.8402 12.64 11.6402L8.85 7.85018Z"
    />
  </g>
</template>
